import React from "react";
import ImageSlider from "../ui/ImageSlider";
import { HomeHeader } from "./HomeHeader";
import { ConfigBanner } from "@nusrif/types";
import { useConfig } from "@nusrif/contexts";
import { useNavigate } from "react-router";
import { Loader } from "lucide-react";
import { getDeviceType } from "@nusrif/utils";

type BannerSlideProps = {
  banner: ConfigBanner;
  onClick?: (path?: string) => void;
};

const BannerSlide: React.FC<BannerSlideProps> = ({ banner, onClick }) => {
  const [imgLoaded, setImgLoaded] = React.useState(false);

  return (
    <button
      onClick={() => onClick?.(banner.urlPath)}
      className="w-full flex-shrink-0"
    >
      {!imgLoaded && (
        <div
          className="w-full animate-pulse bg-gray-200 flex items-center justify-center"
          style={{ maxHeight: "60vh", height: "60vh", minHeight: 414 }}
        >
          <Loader className="animate-spin text-gray-400" />
        </div>
      )}

      <img
        src={banner.image}
        alt={banner.name}
        className={`w-full object-cover transition-opacity duration-300 ${
          imgLoaded ? "opacity-100" : "opacity-0"
        }`}
        style={{
          maxHeight: "60vh",
          position: imgLoaded ? "static" : "absolute",
        }}
        onLoad={() => setImgLoaded(true)}
      />
    </button>
  );
};

const PromotionalBannersLong: React.FC = () => {
  const navigate = useNavigate();
  const config = useConfig();

  const handleGetNowClick = (urlPath?: string) => {
    if (urlPath) navigate(urlPath);
  };

  return (
    <div className="w-full">
      <div className="w-full relative flex gap-4 overflow-x-auto scrollbar-hide">
        {/* HomeHeader absolutely positioned on top of ImageSlider */}
        <div className="absolute left-0 top-0 z-10 w-full pointer-events-none flex justify-between px-5 space-y-6">
          <div className="w-full pt-5 pb-3 pointer-events-auto">
            <HomeHeader />
          </div>
        </div>

        {(getDeviceType() === "desktop" || getDeviceType() === "tablet") && (
          <ImageSlider>
            {config.desktopBanners && config.desktopBanners.map(
              (banner: ConfigBanner, index: number) => (
                <BannerSlide
                  key={index}
                  banner={banner}
                  onClick={handleGetNowClick}
                />
              )
            )}
          </ImageSlider>
        )}
        {(getDeviceType() === "mobile") && (
          <ImageSlider>
            {config.landingBannersLong && config.landingBannersLong.map(
              (banner: ConfigBanner, index: number) => (
                <BannerSlide
                  key={index}
                  banner={banner}
                  onClick={handleGetNowClick}
                />
              )
            )}
          </ImageSlider>
        )}
      </div>
    </div>
  );
};

export { PromotionalBannersLong };
